import React, { useState } from 'react';
import HomeIcon from '@material-ui/icons/Home';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { Radio } from '@material-ui/core';
import { RMSButton } from '../../../shared/components/buttons';
import { useEvidenceNavPreferences } from '../../hooks/useEvidenceNavPreferences';
const NavVisibilitySection = () => {
  const {
    navItemsDef,
    order,
    hidden,
    defaultId,
    setOrder,
    toggleHidden,
    setDefaultId,
    isDirty,
    savePreferences,
  } = useEvidenceNavPreferences();

  const [dragId, setDragId] = useState(null);

  const onDragStart = (id) => setDragId(id);

  const onDragOver = (e, overId) => {
    e.preventDefault();
    if (!dragId || dragId === overId) return;
    const next = [...order];
    const fromIndex = next.indexOf(dragId);
    const toIndex = next.indexOf(overId);
    next.splice(fromIndex, 1);
    next.splice(toIndex, 0, dragId);
    setOrder(next);
  };

  const onDrop = () => setDragId(null);

  return (
    <div className="ev-pref-card">
      <div className="ev-pref-card__header">
        <HomeIcon fontSize="small" />
        <div>
          <div className="ev-pref-card__title">Default Login Location &amp; Menu Visibility</div>
          <div className="ev-pref-card__subtitle">
            Drag rows to reorder · choose your default page · show or hide items
          </div>
        </div>
      </div>

      <div className="ev-pref-nav-table">
        <div className="ev-pref-nav-table__columns">
          <span className="ev-pref-nav-table__col-drag" />
          <span className="ev-pref-nav-table__col-page">Page</span>
          <span className="ev-pref-nav-table__col-default">Default</span>
          <span className="ev-pref-nav-table__col-visible">Visible</span>
        </div>

        {order.map((id) => {
          const item = navItemsDef.find((i) => i.id === id);
          if (!item) return null;
          const isDefault = defaultId === item.id;
          const isHidden = hidden.includes(item.id);
          const ItemIcon = item.Icon;

          return (
            <div
              key={item.id}
              draggable
              onDragStart={() => onDragStart(item.id)}
              onDragOver={(e) => onDragOver(e, item.id)}
              onDrop={onDrop}
              className={`ev-pref-nav-row${isDefault ? ' is-default' : ''}`}>
              <DragIndicatorIcon fontSize="small" className="ev-pref-nav-row__drag-handle" />
              <ItemIcon
                fontSize="small"
                className={`ev-pref-nav-row__icon${isHidden ? ' is-hidden' : ''}`}
              />
              <span className={`ev-pref-nav-row__label${isHidden ? ' is-hidden' : ''}`}>
                {item.label}
              </span>

              <label className={`ev-pref-nav-row__default-radio${isHidden ? ' is-disabled' : ''}`}>
                <Radio
                  checked={isDefault}
                  disabled={isHidden}
                  onChange={() => setDefaultId(item.id)}
                  size="small"
                  color="primary"
                />
                {isDefault && <span className="ev-pref-nav-row__active-tag">Active</span>}
              </label>

              <RMSButton
                label={isHidden ? 'Show' : 'Hide'}
                variant="outlined"
                color="primary"
                size="small"
                className={`ev-pref-nav-row__visibility-btn${isHidden ? ' is-hidden' : ''}`}
                onClick={() => toggleHidden(item.id)}
              />
            </div>
          );
        })}
      </div>

      <div className="ev-pref-nav-footer">
        <RMSButton
          label="Save Preferences"
          variant="contained"
          color="primary"
          size="small"
          disabled={!isDirty}
          onClick={savePreferences}
        />
      </div>
    </div>
  );
};

export default NavVisibilitySection;